
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 33","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.46 7.5H.04V2.46h12.42V7.5zm0 7.5H.04v5.04h12.42V15zm33.985 17.46l-9.492-9.491a15.719 15.719 0 01-3.281 1.523 14.038 14.038 0 01-3.633.469c-2.344 0-4.453-.547-6.328-1.64-1.875-1.094-3.398-2.579-4.57-4.454A12.74 12.74 0 0117.5 12.54c0-2.344.547-4.453 1.64-6.328 1.172-1.875 2.696-3.36 4.57-4.453C25.587.586 27.696 0 30.04 0c2.265 0 4.335.586 6.21 1.758 1.953 1.094 3.477 2.578 4.57 4.453 1.094 1.875 1.64 3.984 1.64 6.328 0 1.25-.194 2.461-.585 3.633a10.563 10.563 0 01-1.406 3.164l9.492 9.61-3.516 3.515zM37.54 12.54c0-1.407-.352-2.657-1.055-3.75a7.168 7.168 0 00-2.812-2.696 6.58 6.58 0 00-3.633-1.055c-1.406 0-2.695.352-3.867 1.055-1.094.625-1.992 1.523-2.695 2.695-.625 1.094-.938 2.344-.938 3.75 0 1.328.313 2.578.938 3.75a8.871 8.871 0 002.695 2.695c1.172.703 2.46 1.055 3.867 1.055a6.58 6.58 0 003.633-1.055c1.172-.703 2.11-1.601 2.812-2.695a7.168 7.168 0 001.055-3.75zM.04 32.46H25v-4.92H.04v4.92z"}})])
          )
        }
      }
    